<template>
  <div class="ScrollContainer" :style="{}">

    <slot>
    </slot>

  </div>
</template>

<script>

//import ScrollVideo from '@assets/components/ScrollVideo.vue'
import { eventBus } from '@/utils'

export default {
  name: 'ScrollContainer',
  props: {
  },
  data: function () {
    return {
    }
  },
  computed: {
  },
  methods: {
  },
  created: function () {
  },
  mounted: function () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.ScrollContainer{
  flex: 1;
  display: flex;
  flex-direction: column;
}

</style>
